module.exports = __webpack_public_path__ + "add.8cf99bc2.svg";